import request from 'sb-request'


/**
 * fetch products for PopularInStatesPage page
 * @param {String} state
 * @param {String} gender
 * @returns {*}
 */
const fetchProducts = (state, gender) =>
  request.post('graphql?name=stateRecommendations', {
    body: {
      query: `{
        items: stateRecommendations(stateName: "${state}", gender: "${gender}", limit: "3", offset: "19") {
          id
          img
          url
          brand
          name
          category
          price
          sex
          type
          rating
          labels
          popularIn
          upchargePrice
          totalPurchasedInState
          totalPurchased
        }
      }`,
    },
  })
    .then(
      ({ items = [] }) => items,
      () => []
    )


export default {
  fetchProducts,
}
